export default {
  nprogress: 50,
  tooltip: 35,
  modal: 30,
  sideMenu: 20,
  header: 10,
  userInfo: 8,
  main: 5,
  graphic: 0,
};
